import { useState, useEffect, useCallback } from 'react';
import { AuditCard } from './AuditCard/index';
import {
  Card,
  InfiniteScroll,
  VerticalFlex,
} from '@trufla-technology/trumarket-react-design-system';
import './style.scss';
import { mockAudits } from './mockAudits';
import { AuditsType } from 'app/types/User';
import { AuditsLoading } from './AuditsLoading';

type Props = {
  audits: AuditsType;
  loading?: boolean;
  paging?: any;
  query?: any;
  handleOffset?: (offset: number) => void;
};

export const Audits = ({
  audits,
  loading,
  handleOffset,
  paging,
  query,
}: Props) => {
  let [data, setData] = useState<AuditsType>([]);

  useEffect(() => {
    if (!audits) return;
    setData([...data!, ...audits]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audits]);

  const loadMore = useCallback(() => {
    if (data?.length === paging?.count) return;

    handleOffset?.(query.paginate?.limit! + query.paginate?.offset!);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  if (loading) return <AuditsLoading />;

  if (!data?.length) return <div className="no-audits">No Audits</div>;

  return (
    <div className="tru-client-details-wrapper">
      <Card type="ghost">
        <VerticalFlex>
          <InfiniteScroll
            data={data!}
            itemContent={(index, audit) => (
              <AuditCard
                key={audit.key}
                audit={audit}
                lastItem={mockAudits?.length === index + 1}
              />
            )}
            loadMore={loadMore}
          />
        </VerticalFlex>
      </Card>
    </div>
  );
};
